import firebase from 'firebase/compat/app';
import Vue from 'vue';
import Vuex from 'vuex';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueObserveVisibility from 'vue-observe-visibility';
// import GAuth from 'vue-google-oauth2';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/styles/custom.scss';

const firebaseConfig = {
  apiKey: 'AIzaSyCETYT6Sg9nGkzX3UGbvicFjWfpdz0_3OY',
  authDomain: 'gunter-68169.firebaseapp.com',
  projectId: 'gunter-68169',
  storageBucket: 'gunter-68169.appspot.com',
  messagingSenderId: '165097666344',
  appId: '1:165097666344:web:dfef4fe63116e5d11d021d',
  measurementId: 'G-63W8KCQKSC',
};

firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueObserveVisibility);
// Vue.use(GAuth, {
//   clientId: '382580914145-qcae0vs10mbjmfg3on707fngnbetk1k8.apps.googleusercontent.com',
// });
// Vue.use(GAuth, gauthOption);

Vue.mixin({
  methods: {
    can(key, value) {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        const permission = user.permissions.find((perm) => perm.name === key);
        return permission.value === value;
      }
      return false;
    },
    initFormlessFloatingLabels() {
      const floatingLabels = document.getElementsByClassName('floating-label');
      for (let i = 0; i < floatingLabels.length; i += 1) {
        const input = floatingLabels[i].nextElementSibling;
        const label = floatingLabels[i];
        if (input && (input.tagName === 'INPUT' || input.tagName === 'TEXTAREA' || input.tagName === 'SELECT')) {
          if (input.value === '') {
            label.classList.remove('active');
          } else {
            label.classList.add('active');
          }

          input.addEventListener('blur', () => {
            if (input.value === '') {
              label.classList.remove('active');
            }
          });

          input.addEventListener('focus', () => {
            label.classList.add('active');
          });
        }
      }
    },
    initFloatingLabels() {
      const forms = document.getElementsByTagName('form');
      for (let i = 0; i < forms.length; i += 1) {
        const inputs = forms[i].querySelectorAll('input, textarea, select');
        for (let j = 0; j < inputs.length; j += 1) {
          const label = inputs[j].previousElementSibling;
          if (label) {
            if (inputs[j].value === '') {
              label.classList.remove('active');
            } else {
              label.classList.add('active');
            }

            inputs[j].addEventListener('blur', () => {
              if (inputs[j].value === '') {
                label.classList.remove('active');
              }
            });

            inputs[j].addEventListener('focus', () => {
              label.classList.add('active');
            });
          }
        }
      }
    },
  },
});

// const token = localStorage.getItem('access');
// const valid = token != null;

// const store = new Vuex.Store({
//   state: {
//     authorized: valid,
//   },
//   mutations: {
//     authenticate(state, payload) {
//       state.authorized = true;
//       localStorage.access = payload.jwt.access;
//       localStorage.refresh = payload.jwt.refresh;
//     },
//     deAuthenticate(state) {
//       state.authorized = false;
//       localStorage.clear();
//       router.push('/login');
//     },
//   },
//   getters: {
//     isAuthenticated(state) {
//       if (!state.jwt || state.jwt.split('.').length < 3) {
//         return false;
//       }
//       const data = JSON.parse(atob(state.jwt.split('.')[1]));
//       const exp = new Date(data.exp * 1000);
//       const now = new Date();
//       return now < exp;
//     },
//   },
// });

new Vue({
  router,
  render: (h) => h(App),
  store,
}).$mount('#app');
